package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.pms_config

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.operation.get_cash_register_config.GetCashRegister
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.PMSType
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ListApaleoProperty
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.dom.Text

@Composable
fun PMSConfig(
    selectedCashRegisterConfigData: GetCashRegister?,
    apaleoProperties: List<ListApaleoProperty?>?,
    updateCashRegisterConfig: (title: String, value: dynamic) -> Unit,
)
{
    val ipRegex = Constants.ipRegex.trimMargin().toRegex()
    val pmsType:MutableState<String?> = remember {
        mutableStateOf(selectedCashRegisterConfigData?.parameters?.pmsType)
    }
    LaunchedEffect(selectedCashRegisterConfigData){
        pmsType.value=selectedCashRegisterConfigData?.parameters?.pmsType
    }


    Column(
        modifier = Modifier
            .borderSetting()
            .fillMaxWidth()
            .borderRadius(Dimen.semiLargeRadius)
            .showContentInOnePage()
            .padding(Dimen.extraLargePadding,)
    )
    {
        DropDownItem(
            modifier = Modifier
                .margin(bottom = Dimen.extraLargePadding),
            label =Strings.current().pmsType ,
            options = PMSType.entries,
            selectedItem =PMSType.entries.find {
                it.value==pmsType.value
            },
            displayText = {
                if (it is PMSType)
                    it.title else ""
            },
            onOptionClick = {
                if (it is PMSType){
                    pmsType.value=it.value
                    updateCashRegisterConfig(
                        ApiUtils.Field.pmsType,
                        it.value
                    )
                }

            },
        )
        when(pmsType.value){

            PMSType.DISABLED.value->{}

            PMSType.PROTEL.value->{
                Column()
                {
                    CustomEditText(
                        modifier = Modifier ,
//                        helperText =Strings.current().noValidIPAddress ,
                        width = Dimen.mediumEditTextWidth,
                        label = Strings.current().ipAddress,
                        value =selectedCashRegisterConfigData
                            ?.parameters?.pmsProtelIP?:"",
                        onFocusIn = { },
                        onFocusOut = {
                            updateCashRegisterConfig(
                                ApiUtils.Field.pmsProtelIP,
                                it,
                            )
                        },
                        onInputChange = { newValue, validation ->
//                            val isValid = ipRegex.matches(newValue)
//                            validation.value = isValid
                        },
                    )

                    CustomEditText(
                        modifier = Modifier ,
                        width = Dimen.mediumEditTextWidth,
                        label = Strings.current().port,
                        value =selectedCashRegisterConfigData
                            ?.parameters?.pmsProtelPort?:"",
                        onFocusIn = { },
                        onInputChange = { newValue, validation ->

                        },
                        onFocusOut = {
                            updateCashRegisterConfig(
                                ApiUtils.Field.pmsProtelPort,
                                it,
                            )
                        },
                    )

                }
            }
            PMSType.APALEO.value-> {
                Column()
                {
                    DropDownItem(
                        modifier = Modifier
                            .margin(bottom = Dimen.extraLargePadding),
                        label =Strings.current().apaleoPMSProperty ,
                        options = apaleoProperties?: listOf(),
                        selectedItem =apaleoProperties?.find {
                            it?.id==selectedCashRegisterConfigData
                                ?.parameters?.apaleoPmsProperty
                        },
                        displayText = {
                            if (it is ListApaleoProperty?)
                                it.name?:"" else ""
                        },
                        onOptionClick = {
                            if (it is ListApaleoProperty?){
                                updateCashRegisterConfig(
                                    ApiUtils.Field.apaleoPmsProperty,
                                    it.id,
                                )
                            }

                        },
                    )
                }
            }

        }

        CheckboxComponent(
            title = Strings.current().transferAllDocuments,
            checkStatus =selectedCashRegisterConfigData?.parameters?.nonGuestTransfer?:false ,
            onChecked = {
                updateCashRegisterConfig(
                    ApiUtils.Field.nonGuestTransfer,
                    true
                )
            },
            onUnChecked = {
                updateCashRegisterConfig(
                    ApiUtils.Field.nonGuestTransfer,
                    false,
                )
            }
        )

        CheckboxComponent(
            title = Strings.current().printReceiptAutomatically,
            checkStatus =selectedCashRegisterConfigData?.parameters?.pmsAutoPrintBills?:false ,
            onChecked = {
                updateCashRegisterConfig(
                    ApiUtils.Field.pmsAutoPrintBills,
                    true
                )
            },
            onUnChecked = {
                updateCashRegisterConfig(
                    ApiUtils.Field.pmsAutoPrintBills,
                    false
                )
            }
        )

    }

}
